import { ITShirtSize } from "interfaces";
import { abbreviateNumbers, formatNumber } from "utills/helpers";

interface TShirtSizeCardProps {
  data?: ITShirtSize[];
  pageSize: number;
  currentPage: number;
  isLoading: boolean;
}

export const TShirtSizeCard = ({data = [], pageSize = 10, currentPage = 1, isLoading }: TShirtSizeCardProps) => {

  return (
    <ul className="bg-white">
      {data.map((item: ITShirtSize, index: number) => (
        <div key={index} className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl">
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              No
            </p>
            <p className="flex-1 text-right text-sm leading-6">{(currentPage - 1) * pageSize + 1 + index}</p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Tshirt size 
            </p>
            <p className="flex-1 text-right text-sm leading-6">{item.t_shirt_size}</p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Distance
            </p>
            <p className="flex-1 text-right text-sm leading-6">{item.category_name_en}</p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Gender
            </p>
            <p className="flex-1 text-right text-sm leading-6">{item.gender}</p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Quantity
            </p>
            <p 
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.quantity)}
            >
              {abbreviateNumbers(item.quantity)}
            </p>
          </li>
        </div>
      ))}
    </ul>
  )
}